"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomSheet = BottomSheet;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/BottomSheet/index.tsx
// Figma: CustomBottomSheet — 画面下から せり上がるシート。
// 券種選択 / 種類選択 / 枚数選択で使う。
//
// 構造:
//   暗幕 (background.overlay) の上に、下端固定・上角 16px のシート。
//   NavigationBar (56px) — 左に戻る / 右に閉じる / 中央にタイトル
//   Body                — スクロール領域 (px20 / py16 / gap16)
//   footer              — 任意。CTA を置く固定フッタ
//
// シートは内容に応じて高さが伸び、画面上端から 40px を残して打ち止め
// (それ以上は Body がスクロールする)。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
/** シート上端に残す余白 px (Figma: pt-40) */
var TOP_GAP = 40;
function BottomSheet(_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, onBack = _a.onBack, showClose = _a.showClose, footer = _a.footer, children = _a.children;
    var p = (0, theme_1.useV2Palette)();
    var withClose = showClose !== null && showClose !== void 0 ? showClose : !onBack;
    return ((0, jsx_runtime_1.jsxs)(material_1.Drawer, { anchor: "bottom", open: open, onClose: onClose, slotProps: {
            backdrop: { sx: { backgroundColor: p.background.overlay } },
        }, PaperProps: {
            sx: {
                backgroundColor: p.background.base,
                backgroundImage: 'none',
                borderTopLeftRadius: "".concat(tokens_1.radius.lg, "px"),
                borderTopRightRadius: "".concat(tokens_1.radius.lg, "px"),
                maxHeight: "calc(100dvh - ".concat(TOP_GAP, "px)"),
                overflow: 'hidden',
            },
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    position: 'relative',
                    height: 56,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: [onBack && ((0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "\u623B\u308B", onClick: onBack, sx: {
                            position: 'absolute',
                            left: tokens_1.spacing.sm,
                            width: 44,
                            height: 44,
                            color: p.foreground.neutral.primary,
                        }, children: (0, jsx_runtime_1.jsx)(Icons_1.ArrowLeftIcon, { sx: { fontSize: 24 } }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.subsectionTitle), { lineHeight: "".concat(tokens_1.lineHeight.md, "px"), color: p.foreground.neutral.primary, textAlign: 'center', 
                            // 左右のアイコンボタン幅ぶんを避ける
                            px: "".concat(44 + tokens_1.spacing.sm, "px") }), children: title }), withClose && ((0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "\u9589\u3058\u308B", onClick: onClose, sx: {
                            position: 'absolute',
                            right: tokens_1.spacing.sm,
                            width: 44,
                            height: 44,
                            color: p.foreground.neutral.primary,
                        }, children: (0, jsx_runtime_1.jsx)(Icons_1.XIcon, { sx: { fontSize: 24 } }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.md, "px"), sx: {
                    flex: '1 1 auto',
                    minHeight: 0,
                    overflowY: 'auto',
                    px: "".concat(tokens_1.spacing.lg, "px"),
                    py: "".concat(tokens_1.spacing.md, "px"),
                    // スクロールバー非表示 (他の v2 レイアウトと揃える)
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                }, children: children }), footer && ((0, jsx_runtime_1.jsx)(material_1.Stack, { alignItems: "center", sx: {
                    flexShrink: 0,
                    px: "".concat(tokens_1.spacing.lg, "px"),
                    pt: "".concat(tokens_1.spacing.md, "px"),
                    pb: "calc(".concat(tokens_1.spacing.md, "px + env(safe-area-inset-bottom, 0px))"),
                }, children: footer }))] }));
}
